// DashboardLayout.js
import React, { useState } from "react";
import styled from "styled-components";
import Sidebar from "./Sidebar";
import DashboardHeader from "./DashboardHeader";
import { THEME_COLORS } from "../../ThemeConfig";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const DashboardLayout = ({ expertData, children }) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarCollapsed((prev) => !prev);
  };

  return (
    <>
      <Header>
        <DashboardHeader expertData={expertData} />
      </Header>

      <SidebarContainer collapsed={isSidebarCollapsed}>
        <ToggleButton onClick={toggleSidebar} collapsed={isSidebarCollapsed}>
          {isSidebarCollapsed ? (
              <FaChevronRight />
          ) : (
              <FaChevronLeft />
          )}
        </ToggleButton>
        <Sidebar expertData={expertData} collapsed={isSidebarCollapsed} />
      </SidebarContainer>

      <MainContainer collapsed={isSidebarCollapsed}>{children}</MainContainer>
    </>
  );
};

export default DashboardLayout;

const Header = styled.header`
  width: 100%;
  height: 70px;
  background: #fff;
  border-bottom: 1px solid ${THEME_COLORS.divider};
  position: fixed;
  top: 0;
  left: 0;
  z-index: 101;
  display: flex;
  align-items: center;
  padding: 0 20px;
`;

const ToggleButton = styled.button`
  margin-right: 20px;
  position: absolute;
  top: 15px;
  z-index: 9999;
  left: ${({ collapsed }) => (collapsed ? "67px" : "210px")};
  background: white;
  border: none;
  font-size: 10px;
  cursor: pointer;
  color: #366ee3;
  border: 1px solid #e8effe;
  padding: 1px;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }
`;

const SidebarContainer = styled.aside`
  width: ${({ collapsed }) => (collapsed ? "80px" : "224px")};
  position: relative;
  background: #fff;
  height: calc(100vh - 70px);
  padding: 20px 15px;
  position: fixed;
  top: 70px;
  left: 0;
  border-right: 1px solid ${THEME_COLORS.divider};
  z-index: 100;
  transition: width 0.3s ease;
`;

const MainContainer = styled.main`
  margin-left: ${({ collapsed }) => (collapsed ? "80px" : "224px")};
  margin-top: 70px;
  padding: 24px;
  height: calc(100vh - 70px);
  overflow-y: auto;
  background: #f9fafb;
  transition: margin-left 0.3s ease;
`;
